/** 控制台 — 水表列表页（watermeter.vue） */
export default {
  deviceWater: {
    searchPlaceholder: '输入水表名称/设备号',
    waterTypePlaceholder: '水表类型',
    onlineStatusPlaceholder: '在线状态',
    online: '在线',
    offline: '离线',
    search: '查询',
    reset: '重置',
    export: '导出',
    exportCurrentPage: '导出本页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    sectionList: '水表列表',
    sectionCard: '水表卡片',
    add: '新增',
    sortDefault: '默认排序',
    viewList: '列表',
    viewCard: '卡片',
    selectedCount: '已选择 {count} 条数据',
    bindTypeDedicated: '专用表',
    bindTypePublic: '公摊表',
    bindTypeFormula: '公式表',
    bindTagDedicated: '专用',
    bindTagPublic: '公摊',
    bindTagFormula: '公式',
    prepaid: '预付费',
    prepaidStrong: '强控',
    valveOpen: '开阀',
    valveClose: '关阀',
    switchSupportYes: '支持',
    switchSupportNo: '不支持',
    tagValveSupport: '支持阀控',
    tagValveNotSupport: '不支持阀控',
    supportShort: '支持',
    notSupportShort: '不支持',
    colDeviceNo: '设备号',
    colWaterName: '水表名称',
    colBindInfo: '已绑信息',
    colType: '类型',
    colValveSupport: '支持阀控',
    colPayMode: '付费模式',
    colValveStatus: '开关阀状态',
    colOnline: '在线状态',
    colUpdateTime: '最新数据时间',
    colCreateTime: '创建时间',
    copyDeviceNoTip: '点击可复制',
    opColumn: '操作',
    opEdit: '编辑',
    opDetail: '详情',
    unbound: '未绑定',
    emptyNoData: '暂无数据',
    cardDeviceNo: '设备号',
    cardBindInfo: '已绑信息',
    cardPayMode: '付费模式',
    cardLatest: '最新数据',
    popoverBindId: '绑定ID',
    popoverBindName: '绑定信息',
    dialogEditTitle: '编辑水表',
    dialogAddTitle: '新增水表',
    labelDeviceNo: '设备号',
    labelWaterName: '水表名称',
    labelWaterType: '水表类型',
    labelAccessChannel: '接入渠道',
    labelDeviceModel: '设备型号',
    labelValveSupport: '是否支持阀控',
    labelManufacturerNo: '厂家号',
    labelPayMode: '付费模式',
    labelBillingPlan: '计费方案',
    placeholderDeviceNo: '请输入设备号',
    placeholderWaterName: '请输入水表名称',
    placeholderSelectWaterType: '请选择水表类型',
    placeholderSelectChannel: '请选择接入渠道',
    placeholderDeviceModel: '请输入设备型号',
    placeholderSelectValve: '请选择',
    placeholderSelectPayMode: '请选择付费模式',
    placeholderSelectBilling: '请选择计费方案',
    placeholderManufacturer: '请选择厂家号',
    priceOptionLabel: '{name} (¥{price}/吨)',
    btnCancel: '取 消',
    btnConfirm: '确 定',
    saving: '保存中...',
    ruleWaterName: '请输入水表名称',
    ruleSerial: '请输入设备号',
    ruleModel: '请输入设备型号',
    ruleBindType: '请选择水表类型',
    errFetchList: '获取数据失败',
    errFetchWater: '获取水表数据失败',
    errPriceList: '获取水价方案失败',
    successSaveUpdate: '修改成功',
    successSaveAdd: '新增成功',
    errOperation: '操作失败',
    warnNothingToCopy: '无可复制内容',
    successSerialCopied: '设备号已复制',
    errCopy: '复制失败',
    warnNotBound: '该水表未绑定租户',
    warnTenantIdMissing: '租户ID不存在',
    warnNoExportData: '暂无数据可导出',
    warnNoSelectedExport: '请先勾选要导出的数据',
    successExported: '成功导出 {count} 条数据',
    successExportedSelection: '成功导出 {count} 条选中数据',
    successExportedLimit: '共 {total} 条，已导出前 {count} 条',
    errExport: '导出失败',
    exporting: '正在导出...',
    exportSheetName: '水表数据',
    exportFilePrefix: '水表数据',
    importTodo: '导入功能开发中…',
    batchTodo: '批量操作功能开发中…',
    channelNs: '智慧物联-南硕',
    channelNsNew: '智慧物联-南硕(新)',
    channelNsThirdParty: '智慧物联-南硕(三方)',
    channelCameraDirect: '摄像直读',

    waterDrawerTitle: '水表详情',
    waterDrawerColId: '编号',
    waterDrawerColModel: '规格型号',
    waterDrawerColInstallLoc: '安装位置',
    waterDrawerLabelValveSupport: '支持阀控',
    waterDrawerNoBind: '暂无绑定信息',
    waterDrawerNoPricePlan: '暂无水价方案',
    waterDrawerPricePlanLabel: '水费方案',
    waterDrawerPricePerTon: '{price} 元/吨',
    waterDrawerSectionUsage: '近期用水统计',
    waterDrawerLinkFullReport: '查看详细报表',
    waterDrawerColTime: '时间',
    waterDrawerColEndRead: '抄表读数(m³)',
    waterDrawerColConsumption: '用水量(m³)',
    waterDrawerColWaterFee: '水费(元)',
    waterDrawerEmptyUsage: '暂无用水统计数据',
    confirmTitle: '提示',
    confirmValveMsg: '确定要执行{action}操作吗？',
    successValveAction: '{action}操作成功',
    errValveAction: '{action}操作失败',
    warnNoValveSupport: '该水表不支持阀控操作',
    errUpdate: '修改失败',
    ruleChannel: '请选择接入渠道'
  }
}
